import type { FC } from 'react';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import type { TabItem } from '@wix/da-ds/pkg/Tabs';
import { pullDrawingsTabStatus } from '../../../actions/studio/playground';
import { getPlaygroundSubsection } from '../../../selectors/studio';
import { BiData, ContentNavbarClickBiEvent } from '@wix/da-bi/pkg/events';
import { PlaygroundSubsection } from '../../../types/store';

import s from './PlaygroundTabs.scss';

interface Props {}

const PlaygroundTabs: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const activeTab = useSelector(getPlaygroundSubsection);
  const dispatchPullDrawingsTabStatus = useAction(pullDrawingsTabStatus);

  useEffect(() => {
    dispatchPullDrawingsTabStatus();
  }, [dispatchPullDrawingsTabStatus]);

  return (
    <UnderlinedTabs
      className={s['root']}
      uniformTabWidth={isMobile}
      items={
        [
          {
            label: t('studio.header.tabs.playground.subtabs.dreamup'),
            index: PlaygroundSubsection.DreamUp,
            href: Url.studio({ playground: 'dreamup' }),
            biData: BiData<ContentNavbarClickBiEvent>({
              evid: 120,
              link_name: 'dreamup',
            }),
          },
          {
            label: t('studio.header.tabs.playground.subtabs.draw'),
            index: PlaygroundSubsection.Draw,
            href: Url.studio({
              playground: 'draw',
            }),
            biData: BiData<ContentNavbarClickBiEvent>({
              evid: 120,
              link_name: 'drawings',
            }),
          },
          {
            label: t('studio.header.tabs.playground.subtabs.wixel'),
            index: PlaygroundSubsection.Wixel,
            href: Url.studio({ playground: 'wixel' }),
            biData: BiData<ContentNavbarClickBiEvent>({
              evid: 120,
              link_name: 'wixel',
            }),
            // onClick: dispatchNavigateToWixel,
          },
        ].filter(item => !!item) as TabItem[]
      }
      activeIndex={activeTab}
    />
  );
};

PlaygroundTabs.displayName = 'PlaygroundTabs';

export default PlaygroundTabs;
